import axios from "../../utils/axios";

export const savedCardsListing = () => {
  return axios.get(`/payments/paystack/saved-authorizations`);
};

export const savedCardDelete = (id) => {
  return axios.delete(`/payments/paystack/saved-authorizations/${id}/`);
};
